/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_Hub_HintInputs */

const en_us2_planshare_hub_hint = /** @type {(inputs: Planshare_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A code to send your plan or open someone else's`)
};

const pt_br2_planshare_hub_hint = /** @type {(inputs: Planshare_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um código para enviar o seu plano ou abrir o de alguém`)
};

const pt_pt2_planshare_hub_hint = /** @type {(inputs: Planshare_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um código para enviar o seu plano ou abrir o de alguém`)
};

/** @type {(inputs: Planshare_Hub_HintInputs) => LocalizedString} */
const es_419_planshare_hub_hint = en_us2_planshare_hub_hint;

/** @type {(inputs: Planshare_Hub_HintInputs) => LocalizedString} */
const fr_fr2_planshare_hub_hint = en_us2_planshare_hub_hint;

/** @type {(inputs: Planshare_Hub_HintInputs) => LocalizedString} */
const de_de2_planshare_hub_hint = en_us2_planshare_hub_hint;

/** @type {(inputs: Planshare_Hub_HintInputs) => LocalizedString} */
const it_it2_planshare_hub_hint = en_us2_planshare_hub_hint;

/**
* | output |
* | --- |
* | "A code to send your plan or open someone else's" |
*
* @param {Planshare_Hub_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_hub_hint = /** @type {((inputs?: Planshare_Hub_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Hub_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_hub_hint(inputs)
	if (locale === "es-419") return es_419_planshare_hub_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_hub_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_hub_hint(inputs)
	if (locale === "de-DE") return de_de2_planshare_hub_hint(inputs)
	if (locale === "it-IT") return it_it2_planshare_hub_hint(inputs)
	return en_us2_planshare_hub_hint(inputs)
});
export { planshare_hub_hint as "planshare.hub_hint" }